import { menuLanguageVersionVar } from "@me-team/host/main/menuLanguageVersions/state";

interface ResetMenuLanguageVersionOnPrimaryChangeParams {
    previousPrimaryLanguageId?: number | null;
    nextPrimaryLanguageId?: number | null;
    resolveNextPrimaryIsoCode: (
        nextPrimaryLanguageId: number
    ) => string | null | undefined | Promise<string | null | undefined>;
}

export const resetMenuLanguageVersionOnPrimaryChange = async ({
    previousPrimaryLanguageId,
    nextPrimaryLanguageId,
    resolveNextPrimaryIsoCode,
}: ResetMenuLanguageVersionOnPrimaryChangeParams) => {
    if (previousPrimaryLanguageId === nextPrimaryLanguageId) return;
    if (nextPrimaryLanguageId == null) return;

    const nextPrimaryIsoCode = (await resolveNextPrimaryIsoCode(nextPrimaryLanguageId))?.trim() || null;
    if (!nextPrimaryIsoCode) return;

    menuLanguageVersionVar(nextPrimaryIsoCode);
};
